import { useEffect, useMemo, useState } from "react";

const COMMANDS = [
  { id: "mail", label: "Go to Mail", run: "nav:/mail" },
  { id: "cal", label: "Go to Calendar", run: "nav:/calendar" },
  { id: "people", label: "Go to Contacts", run: "nav:/contacts" },
  { id: "settings", label: "Go to Settings", run: "nav:/settings" },
  { id: "compose", label: "Compose message", run: "compose" },
  { id: "theme-dawn", label: "Tema: Chiaro", run: "theme:dawn" },
  { id: "theme-mist", label: "Tema: Nebbia", run: "theme:mist" },
  { id: "theme-ink", label: "Tema: Inchiostro (scuro)", run: "theme:ink" },
  { id: "theme-midnight", label: "Tema: Mezzanotte", run: "theme:midnight" },
  { id: "help", label: "Keyboard help (j/k navigate, c compose, / search, e archive)", run: "help" },
];

export function CommandPalette({
  onClose,
  onNavigate,
  onTheme,
}: {
  onClose: () => void;
  onNavigate: (path: string) => void;
  onTheme: (theme: string) => void;
}) {
  const [q, setQ] = useState("");
  const [idx, setIdx] = useState(0);
  const items = useMemo(() => {
    const s = q.trim().toLowerCase();
    return COMMANDS.filter((c) => !s || c.label.toLowerCase().includes(s));
  }, [q]);

  useEffect(() => setIdx(0), [q]);

  function run(cmd: (typeof COMMANDS)[number]) {
    if (cmd.run.startsWith("nav:")) onNavigate(cmd.run.slice(4));
    else if (cmd.run === "compose") {
      window.dispatchEvent(new CustomEvent("mailstorm:compose"));
      onClose();
    } else if (cmd.run.startsWith("theme:")) {
      onTheme(cmd.run.slice(6));
      onClose();
    } else onClose();
  }

  return (
    <div className="modal-back" onClick={onClose}>
      <div className="modal palette" onClick={(e) => e.stopPropagation()}>
        <input
          className="input"
          autoFocus
          placeholder="Type a command or jump…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "ArrowDown") {
              e.preventDefault();
              setIdx((i) => Math.min(items.length - 1, i + 1));
            }
            if (e.key === "ArrowUp") {
              e.preventDefault();
              setIdx((i) => Math.max(0, i - 1));
            }
            if (e.key === "Enter" && items[idx]) run(items[idx]!);
          }}
        />
        <div className="palette-list">
          {items.map((c, i) => (
            <button
              key={c.id}
              className={`palette-item ${i === idx ? "active" : ""}`}
              onMouseEnter={() => setIdx(i)}
              onClick={() => run(c)}
            >
              {c.label}
            </button>
          ))}
          {items.length === 0 && <div className="empty">No commands</div>}
        </div>
      </div>
    </div>
  );
}
